import React from 'react';
import 'remirror/styles/all.css';
import {
    BoldExtension,
    BulletListExtension,
    ItalicExtension,
    OrderedListExtension,
    LinkExtension,
    HardBreakExtension,
    HeadingExtension
} from 'remirror/extensions';
import {
    Remirror,
    EditorComponent,
    useRemirror,
    OnChangeHTML,
    useActive,
    useCommands
} from '@remirror/react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Link, ListOl, ListUl, TypeBold, TypeItalic, CardHeading } from 'react-bootstrap-icons';

const extensions = () => [
    new BoldExtension({}),
    new ItalicExtension(),
    new BulletListExtension({}),
    new OrderedListExtension(),
    new LinkExtension({}),
    new HardBreakExtension({}),
    new HeadingExtension({}),
];

type Props = {
    value: string,
    onChange: (html: string) => void
}

const RichTextField = ({ value, onChange }: Props) => {
    return (
        <div className="RichTextField">
            <Editor onChange={onChange} content={value} />
        </div>
    )
};

export default RichTextField;

type EditorProps = { onChange: (html: string) => void, content: string };
const Editor = ({ onChange, content }: EditorProps) => {
    const { manager, state } = useRemirror({
        extensions,
        content,
        stringHandler: 'html',
        selection: 'end',
    });

    return (
        <div className='Editor'>
            <Remirror manager={manager} initialContent={state}>
                <Menu />
                <EditorComponent />
                <OnChangeHTML onChange={onChange} />
            </Remirror>
        </div>
    );
};

const Menu = () => {
    const commands = useCommands();
    const active = useActive();

    const boldClick = () => {
        commands.toggleBold();
    };

    const italicClick = () => {
        commands.toggleItalic();
    };

    const bulletListClick = () => {
        commands.toggleBulletList();
    };

    const orderedListClick = () => {
        commands.toggleOrderedList();
    };

    const linkClick = () => {
        const activeLink = active.link();

        if (activeLink) {
            commands.removeLink();
        } else {
            const url = prompt('Enter the URL', 'https://');
            if (url) {
                commands.updateLink({ href: url, target: '_blank' });
            }
        }
    };

    const headingClick = () => {
        commands.toggleHeading({ level: 2 });
    };

    return (
        <div style={{ padding: '0.25rem 0' }}>
            <ButtonGroup>
                <Button variant='editor' active={active.heading({ level: 2 })} onClick={headingClick}>
                    H2
                </Button>
                <Button variant='editor' active={active.bold()} onClick={boldClick}><TypeBold /></Button>
                <Button variant='editor' active={active.italic()} onClick={italicClick}><TypeItalic /></Button>
            </ButtonGroup>
            <div className="vr"></div>
            <ButtonGroup>
                <Button variant='editor' active={active.bulletList()} onClick={bulletListClick}><ListUl /></Button>
                <Button variant='editor' active={active.orderedList()} onClick={orderedListClick}><ListOl /></Button>
            </ButtonGroup>
            <div className="vr"></div>
            <ButtonGroup>
                <Button variant='editor' active={active.link()} onClick={linkClick}><Link /></Button>
            </ButtonGroup>
        </div>
    );
};